import { calculateCentroid } from "../math/utils";
import { generateUid } from "./uid";
/**
 * Face that will render as a puzzle sticker
 */
export class Face {
    /**
     * @param indices indices of vertices that make up a face
     * @param vertices vertices of the geometry to calculate centroid from
     * @param color color of the sticker
     */
    constructor(indices, vertices, color) {
        this.indices = indices;
        this.color = color;
        this.uid = generateUid();
        if (vertices) {
            this.calculateCentroid(vertices);
        }
    }
    /**
     * recalculate the centroid of the face.
     */
    calculateCentroid(vertices) {
        this.centroid = calculateCentroid(
        // Calculate centroid from vertices included in the face
        vertices.filter((v, i) => this.indices.includes(i)));
    }
}
